export const DEFAULT_PAGE_SIZE = 10;
export const INPUT_TYPE_DEBOUNCE = 400;
export const SMALL_TEXT_MAX_LENGTH = 64;
export const MEDIUM_TEXT_MAX_LENGTH = 254;
export const LONG_TEXT_MAX_LENGTH = 256;
export const QUERY_REFETCH_INTERVAL_MS_30S = 30_000;
export const QUERY_REFETCH_INTERVAL_MS_60S = 60_000;
export const QUERY_STALE_TIME_MS_30S = 30_000;
export const MILISECONDS_TO_REFRESH_EXTRACTION_STATUS = QUERY_REFETCH_INTERVAL_MS_30S;
export const NAME_INPUT_MAX_LENGTH = 128;
export const PASSWORD_MIN_LENGTH = 12;
export const PDF_PAGES_CUTOFF = 200;
export const TEXT_FILE_DISPLAY_MAX_SIZE = 50_000_000; // bytes
export const JSON_FILE_TREE_DISPLAY_MAX_SIZE = 5_000_000; // bytes
export const THREE_D_FILE_DIFF_MAX_SIZE = 50_000_000; // bytes
export const THROTTLE_MS = 500;
export const ZITADEL_RELOAD_DELAY = 300;
export const DEFAULT_CACHE_TIME = 5 * 60 * 1000; // 5 minutes
export const QUERY_GC_TIME_MS_30M = 30 * 60 * 1000; // 30 minutes: gcTime for stable catalog queries (F49)
